"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircledNumber = exports.COLORS = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("./style.scss");
var COLORS;
(function (COLORS) {
    COLORS["PRIMARY"] = "PRIMARY";
    COLORS["DANGER"] = "DANGER";
    COLORS["WARNING"] = "WARNING";
})(COLORS || (exports.COLORS = COLORS = {}));
const CircledNumber = ({ number = 0, color = COLORS.PRIMARY, }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('circled-number', color?.toLowerCase(), {
        large: number && JSON.stringify(number).length > 2,
    }) }, number));
exports.CircledNumber = CircledNumber;
CircledNumber.COLORS = COLORS;
